import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'

import useHasValidAuthSession from '~/features/auth/hooks/useHasValidAuthSession'
import { TUserDetail } from '~/features/user/models'
import { queryKeys } from '~/features/user/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

const useGetUser = (userId: string, options?: { retry?: boolean }) => {
  const { hasValidAuthSession } = useHasValidAuthSession()

  const queryFn = useCallback(
    () =>
      HttpService.get<TUserDetail>(
        { path: pathBuilder(EServerPath.user, { userId }) },
        EHttpService.internal,
      ),
    [userId],
  )

  return useQuery({
    // Only an authenticated user can read user details; wait for the grouped
    // token so we never mis-route to the Amplify backend during sign-in.
    enabled: !!userId && hasValidAuthSession,
    queryKey: queryKeys.user(userId),
    queryFn,
    retry: !!options?.retry,
  })
}

export default useGetUser
